import React from 'react';

interface Props {
    calledOutRacialTraits: Array<string>;
}
export default class RacialTraitsShortDescription extends React.PureComponent<Props> {
    render() {
        const { calledOutRacialTraits } = this.props;

        if (!calledOutRacialTraits.length) {
            return null;
        }

        return (
            <div className="ddbc-racial-traits-short-description">
                <div className="ddbc-racial-traits-short-description__title">Racial Traits</div>
                <div className="ddbc-racial-traits-short-description__traits">{calledOutRacialTraits.join(', ')}</div>
            </div>
        );
    }
}
